import { Link } from "react-router-dom";

const STEPS = [
  ["Arrive", "Step into a private appointment, away from noise, waiting rooms and outside pressure."],
  ["Breathe", "We begin by slowing the breath, softening the body and giving your nervous system permission to settle."],
  ["Listen", "Before anything touches your skin, we take a moment to understand how you feel, what your body needs, and what has been heavy lately."],
  ["Receive", "Each treatment is shaped around you — your skin, your energy, your sensitivity, and the kind of care you need that day."],
  ["Tune in", "Time to come back to yourself. To feel your body again, notice your breath, and allow the mind to become quieter."],
  ["Leave lighter", "You leave with calmer skin, a softer body, and simple tools you can carry into your everyday life."],
];

export default function Sanctuary() {
  return (
    <div data-testid="sanctuary-page">
      <section className="pt-24 lg:pt-40 pb-16">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
          <div className="label-eyebrow">What Happens When You Slow Down</div>
          <h1 className="serif mt-7 text-[48px] sm:text-[80px] leading-[1] tracking-tight">
            A private room, <span className="italic">held for you</span>.
          </h1>
          <p className="mt-12 max-w-2xl text-[19px] leading-[1.8] text-[#2E2B27]">
            Studio A was created for the woman who needs <strong>more than a treatment</strong>. It is a private space to <strong>pause, breathe, reconnect with your body</strong> and be cared for without distraction.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-[880px] mx-auto px-6 sm:px-10">
          <div className="w-full aspect-square overflow-hidden">
            <img
              src="/images/studio-room-square-960.webp"
              srcSet="/images/studio-room-square-640.webp 640w, /images/studio-room-square-960.webp 960w, /images/studio-room-square-1280.webp 1280w"
              sizes="(max-width: 768px) calc(100vw - 48px), 800px"
              width="1254"
              height="1254"
              loading="lazy"
              decoding="async"
              alt="Studio A private treatment room in Bondi Beach, with original artwork, stone basin, timber bench and treatment bed."
              data-testid="sanctuary-studio-image"
              className="block w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-2">
          {STEPS.map(([k, v], i) => (
            <div key={k} className="border-t border-[#D5CDBF] py-8" data-testid={`step-${i + 1}`}>
              <div className="flex items-baseline gap-4">
                <span className="label-eyebrow">{String(i + 1).padStart(2, "0")}</span>
                <div className="label-eyebrow">{k}</div>
              </div>
              <p className="mt-5 serif text-[22px] sm:text-[26px] leading-snug">{v}</p>
            </div>
          ))}
        </div>
      </section>

      {/* EDITORIAL BREATH */}
      <section className="py-10">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10 grid grid-cols-12 gap-6 items-end">
          <div className="col-span-5">
            <img src="/images/editorial/plaster-shadow.jpg" alt="Soft shadow of an olive branch on a warm plaster wall." data-testid="sanctuary-plaster-image" className="w-full aspect-[4/5] object-cover" />
          </div>
          <div className="col-span-7">
            <img src="/images/editorial/still-water.jpg" alt="Still water among weathered coastal rocks in morning light." data-testid="sanctuary-water-image" className="w-full aspect-[4/3] object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-[#EAE7E0]/60 py-28">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 text-center">
          <h2 className="serif text-[28px] sm:text-[40px] leading-tight">
            “Finally, a space where my nervous system can soften.”
          </h2>
          <p className="label-eyebrow mt-8">— A client, Bondi</p>
        </div>
      </section>

      <section className="py-32 text-center">
        <Link to="/book" data-testid="sanctuary-book-btn" className="btn-primary inline-flex">
          Begin Your Ritual
        </Link>
      </section>
    </div>
  );
}
